<app-traitement-data titre="EPAP MIN - EPAP MAX" [sousTitre]="patient!.tableauDeBord?.epapMin?.date | aLaDateDu"
    statut="info">
    {{ patient!.tableauDeBord?.epapMin?.value ?? 'Ø' }} - {{ patient!.tableauDeBord?.epapMax?.value ?? 'Ø' }}
</app-traitement-data>